export interface CampusHub {
  id: string;
  label: string;
  address: string;
  icon: "campus" | "train" | "plane" | "bus" | "mall" | "pin";
}

export const POPULAR_CAMPUS_HUBS: CampusHub[] = [
  {
    id: "muj",
    label: "MUJ Campus",
    address: "Manipal University Jaipur, Dahmi Kalan, Rajasthan, India",
    icon: "campus",
  },
  {
    id: "junction",
    label: "Jaipur Junction",
    address: "Jaipur Junction Railway Station, Jaipur, Rajasthan, India",
    icon: "train",
  },
  {
    id: "airport",
    label: "Jaipur Airport",
    address: "Jaipur International Airport, Sanganer, Jaipur, Rajasthan, India",
    icon: "plane",
  },
  {
    id: "sindhicamp",
    label: "Sindhi Camp",
    address: "Sindhi Camp Bus Stand, Station Road, Jaipur, Rajasthan, India",
    icon: "bus",
  },
  {
    id: "wtp",
    label: "WTP / Malviya Nagar",
    address: "World Trade Park, Malviya Nagar, Jaipur, Rajasthan, India",
    icon: "mall",
  },
  {
    id: "vaishali",
    label: "Vaishali Nagar",
    address: "Vaishali Nagar, Jaipur, Rajasthan, India",
    icon: "pin",
  },
];
